import {SET_CURRENT_LANGUAGE, LOAD_LANGUAGES, LOAD_TRANSLATIONS} from '../actions/types';

const initialState = {
    currentLanguage: {
        code: 'en',
        rtl: false
    },
    languages: [],
    translations: {},
};

export default function (state = initialState, {payload, type} = action) {

    switch (type) {

        case SET_CURRENT_LANGUAGE:

            const languageId = typeof payload === 'object' ? payload.id : parseInt(payload);

            localStorage.setItem('preferred-language-id', languageId);

            let lang = state.languages.find(l => l.id === languageId);

            if (!lang) {
                lang = state.languages.find(l => l.main);
            }

            return {
			    ...state,
			    currentLanguage: lang
		    }

        case LOAD_LANGUAGES:
            const langId = parseInt(localStorage.getItem('preferred-language-id'));

            let currentLanguage = payload.find(lang => {
                return !!langId ? lang.id == langId : lang.main;
            });

            if (!currentLanguage && payload) {
                currentLanguage = payload.find(l => l.main);
            }

            return {
                ...state,
                languages: payload,
                currentLanguage: currentLanguage
            };

        case LOAD_TRANSLATIONS:
            return {
                ...state,
                translations: payload,
            };

        default:
            return state;
    }
}
